export default (link) => {
  let match = link && link.match(/^(\S+):\/\/.*/);
  return match[1];
};
